import BrandFocusSlider from './BrandFocusSlider'; export default BrandFocusSlider;